import React from 'react'


export const Goodbye = () => {

    return (
    <section>    
    <h2>Not seen it?</h2>
    <p className="goodbye-text">Well there's really not much point in continuing the survey, then...</p>
    </section> 
    )
}